import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadAuth } from './GlobalDecode';
export const GlobalHotkeys: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {

    loadAuth();

    const handleKeyDown = (event: KeyboardEvent) => {
      const tag = (event.target as HTMLElement)?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      if (event.key === 'F2') {
        event.preventDefault();
        navigate('/venda/novo');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);
  return null;
};
